import { message } from 'antd';
import { webapi } from './Variable';
import axios from 'axios';
const apiurl = webapi;
const apiClient = axios.create({
    baseURL: webapi,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});
const webPostRaw = async (endpoint, data, navigate) => {
    try {
        const admin = window['admuser'];
        if (!admin && endpoint !== 'admlogin') {
            navigate('/login');
            return;
        }


        const token = admin ? admin?.token : '';
        const apiParams = { 'm': endpoint, 'token': token, ...data };
        const response = await apiClient.post('', apiParams);

        if (response?.data) {
            const res = response.data;
            console.log(apiParams, res);
            if (res?.code === '1') {
                return res?.data;
            } else {
                if (res?.msg === '请重新登录') {
                    navigate('/login');
                    return null;
                }
                message.error(res?.msg || '请求未响应');
                return null;
            }
        } else {
            message.error('无法连接到服务器');
            console.log(apiParams, response);
            return null;
        }
    } catch (error) {
        message.error('请求出错');
        console.log(error);
        return null;
    }
};

export async function webpost(endpoint, data) {
    const admin = window['admuser'];
    if (!admin) return null;
    const token = admin ? admin?.token : '';
    if (token === '') return null;
    try {

        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(item => {
                    formData.append(key, item ?? '');
                });
            } else {
                formData.append(key, value ?? '');
            }
        });
        formData.append('m', endpoint);
        formData.append('token', token);
        const response = await fetch(apiurl, {
            method: 'POST',
            body: formData,
        });
        console.log('webpost:', Array.from(formData.entries()));
        if (response.ok) {
            const res = await response.json();
            console.log('webpostresult:', Array.from(formData.entries()), res);
            if (res?.code === '1') {
                return res?.data;
            } else {
                message.error(res?.msg || '请求未响应');
                return null;
            }
        } else {
            message.error('无法连接到服务器');
            return null;
        }
    } catch (error) {
        message.error('请求出错');
        console.log(error);
        return null;
    }
}

export default webPostRaw;